import React from 'react';
import styles from './Game.module.css';
import Scoreboard from '../components/Scoreboard';
import Timer from '../components/Timer';
import Card from '../components/Card';
import Button from '../components/Button';
import ButtonAlt from '../components/ButtonAlt';
import ButtonReset from '../components/ButtonReset';
import * as constants from '../constants';

const Game = (props) => {

    return (
        <div className={styles.container}>
            <div className={styles.top}>
                <div className={styles.card}>
                    <Card
                        card={props.card}
                        drawCard={props.drawCard}
                        guess={props.guess}
                    />
                </div>
                <div className={styles.right}>
                    <div className={styles.scoreboard}>
                        <Scoreboard teams={props.teams}
                            teamPlays={props.teamPlays}
                            windowWidth={props.windowWidth} />
                    </div>
                    <div className={styles.timer}>
                        <Timer timer={props.timer} />
                    </div>
                </div>
            </div>
            <div className={styles.bottomWrapper}>
                <div className={styles.bottom}>
                    <div className={styles.nextButton}>
                        <Button onClick={props.nextTeam}
                            disabled={!props.card.drawn}>
                            {constants.TEXT16}
                        </Button>
                    </div>
                    <div className={styles.buttons}>
                        <div className={styles.button}>
                            <ButtonAlt onClick={() => {
                                props.changeContainer('help');
                                if (!props.timer.paused) props.pauseTimer(true);
                            }}>{constants.TEXT12}</ButtonAlt>
                        </div>
                        <div className={styles.button}>
                            <ButtonReset resetGame={props.resetGame} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Game;